module.exports = __webpack_public_path__ + "static/media/Daily_Electric_Spank1.8322be70.mp3";